"use client";

import { ProjectQueryPageContent } from "@/app/dashboard/projects/[projectSlug]/query/page";

export function RecordingDemoMarketingQuery() {
  return (
    <div
      id="interactive-demo"
      className="h-[620px] min-w-0 scroll-mt-20 overflow-hidden rounded-xl border border-border bg-background shadow-[0_20px_60px_-36px_rgba(0,0,0,0.35)]"
    >
      <ProjectQueryPageContent
        projectSlugOverride="pdf-to-sqlite-demo"
        publicDemo
      />
    </div>
  );
}
